"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const authHandlers_1 = require("../../handlers/authHandlers");
const native_1 = require("@react-navigation/native");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../store/redux/selectors");
const NavigationWrapperWeb_1 = __importDefault(require("./NavigationWrapperWeb"));
const react_i18next_1 = require("react-i18next");
const react_device_detect_1 = require("react-device-detect");
const VerifyEmail = () => {
    const navigation = (0, native_1.useNavigation)();
    const isVerified = (0, react_redux_1.useSelector)(selectors_1.getEmailVerified);
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'login_sign_web' });
    const [tokenData, setTokenData] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        const fetchData = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const token = urlParams.get('token');
            if (token) {
                const data = await (0, authHandlers_1.verifyEmailHandler)(token, navigation, react_device_detect_1.isMobile);
                setTokenData(data);
            }
        };
        fetchData();
    }, []);
    const [errors] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'errors' });
    const showPopup = (0, react_redux_1.useSelector)(selectors_1.getShowPopup);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (react_device_detect_1.isMobile) ?
            (0, jsx_runtime_1.jsx)(NavigationWrapperWeb_1.default, { email_verified: true, children: isVerified ?
                    (0, jsx_runtime_1.jsxs)("div", { className: "verify-email", children: [(0, jsx_runtime_1.jsx)("p", { className: "font-16-600", children: t("login.email_verified") }), (0, jsx_runtime_1.jsx)("a", { className: "button button-blue", href: `flyway://?token=${tokenData?.accessToken}&expDate=${tokenData?.expDate}&refresh=${tokenData?.refreshToken}`, children: t("login.continue") })] }) :
                    showPopup && (0, jsx_runtime_1.jsx)("div", { children: errors(showPopup) }) }) :
            (0, jsx_runtime_1.jsx)("div", { children: "Redirecting..." }) }));
};
exports.default = VerifyEmail;
